import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/themeThree/deposit-blue-dark.png'
import _imports_1 from '@/assets/themeThree/bg-blue-dark.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "activeLine"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "activeLine"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "redPoint"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "activeLine"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "activeLine"
}

import RegisterLoginPopup from '@/view/loginRegister/registerLoginPopup.vue';
import { ref, onMounted, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

interface TabItem {
    display: boolean,
    title: string,
    default_url: string,
    redirectUrl: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'mainFooter',
  props: {
    itemData: {},
    activeFooter: {}
  },
  setup(__props: any, { expose: __expose }) {

const router = useRouter();

const props = __props
const userStore = useUserStore()
const tabList = computed(() => props.itemData.tabs);
const activeFooter = ref(props.activeFooter || 0);
const promoCount = computed(() => userStore.totalMsgListCount);
const registerRef = ref();

const goToPath = (path: string, indexValue: number) => {
    activeFooter.value = indexValue
    router.push(path)
    localStorage.setItem('footerPopupOpen', String(activeFooter.value))
}

const setProfileActiveFooter = () => {
    activeFooter.value = 4
}
const handleHistoryOpenPopup = () => {
    const indexNo: any = localStorage.getItem('footerPopupOpen')
    if (indexNo) {
        goToPath(tabList.value[indexNo].redirectUrl, indexNo)
    } else {
        goToPath(tabList.value[0].redirectUrl, 0)
    }

}
watch(activeFooter, (val) => {
    userStore.setIsInHome(val)
})
onMounted(() => {
    handleHistoryOpenPopup()
})
__expose({
    setProfileActiveFooter
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "depositCard" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        width: "100%"
      })
    ], -1)),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "bgCard" }, [
      _createElementVNode("img", {
        src: _imports_1,
        alt: "",
        width: "100%"
      })
    ], -1)),
    _createVNode(_component_van_row, {
      class: "footer",
      justify: "space-between",
      style: {"padding-bottom":"5px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[0].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPath(tabList.value[0].redirectUrl, 0)))
                }, [
                  _createElementVNode("img", {
                    src: tabList.value[0].default_url,
                    alt: ""
                  }, null, 8, _hoisted_1),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: activeFooter.value == 0 ? '#fff' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[0].title)), 5),
                  (activeFooter.value == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[1].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPath(tabList.value[1].redirectUrl, 1)))
                }, [
                  _createElementVNode("img", {
                    src: tabList.value[1].default_url,
                    alt: ""
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: activeFooter.value == 1 ? '#fff' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[1].title)), 5),
                  (activeFooter.value == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_button_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[2].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPath(tabList.value[2].redirectUrl, 2)))
                }, [
                  _createElementVNode("img", {
                    src: tabList.value[2].default_url,
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", {
                    style: _normalizeStyle([{ color: activeFooter.value == 2 ? '#ffffff' : '#94ff7f' }, {"padding-top":"4px"}])
                  }, _toDisplayString(_ctx.$t(tabList.value[2].title)), 5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[3].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPath(tabList.value[3].redirectUrl, 3)))
                }, [
                  (promoCount.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(promoCount.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: tabList.value[3].default_url,
                    alt: ""
                  }, null, 8, _hoisted_7),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: activeFooter.value == 3 ? '#fff' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[3].title)), 5),
                  (activeFooter.value == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[4].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPath(tabList.value[4].redirectUrl, 4)))
                }, [
                  _createElementVNode("img", {
                    src: tabList.value[4].default_url,
                    alt: ""
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: activeFooter.value == 4 ? '#fff' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[4].title)), 5),
                  (activeFooter.value == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(RegisterLoginPopup, {
      ref_key: "registerRef",
      ref: registerRef
    }, null, 512)
  ], 64))
}
}

})